export default "__VITE_ASSET__BDJu6IPG__"